export const modeConstants = {
  ADD_MODE: "ADD_MODE",
  EDIT_MODE: "EDIT_MODE",
  VIEW_MODE: "VIEW_MODE",
  DELETE_MODE: "DELETE_MODE",
  CANCEL_MODE: "CANCEL_MODE",
};
